// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spin-container[data-v-f4b50242] {\n  position: fixed;\n  z-index: 10000;\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.spin-container .ant-spin[data-v-f4b50242],\n.spin-container .ant-spin-lg[data-v-f4b50242],\n.spin-container .ant-spin-spinning[data-v-f4b50242],\n.spin-container .ant-spin-text[data-v-f4b50242] {\n  margin: 40vh 50vw;\n  white-space: nowrap !important;\n}\n", ""]);
// Exports
module.exports = exports;
